import React from "react";

import { NewModal, NewModalContent, NewModalBody, NewModalHeader, NewModalRef, NewModalTitle } from "../NewModal/NewModal";

import Calculator from "../../calculator/calculator";

const CalculatorModal = React.forwardRef<NewModalRef>((_, ref) => {
  return (
    <NewModal ref={ref} isDismissable={false} className="!pb-4 !pt-8 !w-fit !px-4 sm:!px-8">
      <NewModalContent>
        <NewModalHeader>
          <NewModalTitle className="font-normal mb-4 max-w-[28ch]">
            Faça a simulação abaixo e veja o quanto seu cliente pode economizar.
          </NewModalTitle>
        </NewModalHeader>

        <NewModalBody>
          <Calculator className="w-[320px]" />
        </NewModalBody>
      </NewModalContent>
    </NewModal>
  );
});

export default CalculatorModal;
